// extracted by mini-css-extract-plugin
export default {"root":"NoAuthMenubar_root__BIORO","header":"NoAuthMenubar_header__SKWUl"};